import * as types from '@/store/types'
import axios from 'axios'
import constConf from '../../../constconf'
export default {
    loadApp_vk: (context, botId) => {
        axios.defaults.withCredentials = true
        axios.get(constConf.app_v.url + '/app_v/all/' + botId).then(response => {
            if (response.data.length !== 0) {
                context.commit('loadApp_vk', response.data)
            } else {
                context.commit('loadApp_vk', [])
            }
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error get app_v' + error)
        })
    },
    saveApp_v: (context, payload) => {
        let method = 'post'
        let url = constConf.app_v.url + '/app_v'
        if (payload.id != null) {
            method = 'put'
            url += '/' + payload.id
        }
        console.log(payload)
        axios.defaults.withCredentials = true
        return axios({
            method: method,
            url: url,
            data: payload
        })
            .then((response) => {
                let functionName = { put: 'setApp_v', post: 'addApp_v' }
                context.commit(functionName[method], response.data)
                return response.data // рабочий пример возврата данных
            })
            .catch((error) => {
                console.log('ошибка при записи модели app_v')
                console.log(error)
                return null
            })
    },
    removeApp_v: (context, index) => {
        let payload = context.getters.app_vk[index]
        axios({
            method: 'delete',
            url: constConf.app_v.url + '/app_v/' + payload.id
        })
            .then((response) => {
                context.commit('removeApp_v', payload.id)
            })
            .catch((error) => {
                console.log('ошибка при записи значения')
                console.log(error)
            })
    },
    changeBotIdModelDefault: (context, botId) => {
        context.commit('changeBotIdModelDefault', botId)
    },
    getClientInfo: (context, payload) => {
        axios({
            method: 'post',
            url: constConf.app_vk.url + '/app_vk/get-client-info',
            data: payload
        })
            .then((response) => {
                context.commit('getClientInfo', response.data)
            })
            .catch((error) => {
                console.log('ошибка при записи значения')
                console.log(error)
            })
    },
    setClient: (context, payload) => {
        context.commit('setClient', payload)
    },
    loadAllowMessagesGroupList: (context, payload) => {
        axios({
            method: 'get',
            url: constConf.app_vk.url +
                '/app_vk/get-user-allow-group-list/' +
                payload.clientId +
                '?group_id=' + payload.groupId +
                    '&sign=' + context.getters.sign
        })
            .then((response) => {
                if (response.data.type === 'actionGetUserAllowGroupListResult') {
                    context.commit('loadAllowMessagesGroupList', response.data.data)
                }
            })
            .catch((error) => {
                console.log('ошибка при записи значения')
                console.log(error)
            })
    },
    removeClientsInMailingGroup: (context, payload) => {
        return axios.post(constConf.client.url + '/mailinggroup/removeclients',
            { clientIds: payload.clientIds, mailingGroupId: payload.mailingGroupId }).then(response => {
            if ((response.data.isArray || typeof response.data === 'object') && response.data.hasOwnProperty('success')) { context.commit('removeClientsInMailingGroup', response.data) }
            return response.data
            // context.commit('removeClientsInMailingGroup', payload.clientIds)
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error load clients by options' + error)
        })
    },
    unsubscribeClient: (context, payload) => {
        return axios.get(constConf.app_vk.url + '/app_vk/unsubscribe-client/' + payload.clientId + '?mailing_group_id=' + payload.mailingGroupId).then(response => {
            if ((response.data.isArray || typeof response.data === 'object') && response.data.hasOwnProperty('success')) {
                context.commit('unsubscribeClient', response.data)
                let data = { id: response.data.success.data.mailing_group_id, count: 1, subscribe: 0 }
                context.commit('changeCountMailingGroup', data)
                // context.dispatch('mailingGroups/changeCountMailingGroup', data, { root: true })
            }
            return response.data
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error unsubscribeClient ' + error)
        })
    },
    subscribeClient: (context, payload) => {
        return axios.get(constConf.app_vk.url + '/app_vk/subscribe-client/' + payload.clientId + '?mailing_group_id=' + payload.mailingGroupId)
            .then(response => {
                if ((response.data.isArray || typeof response.data === 'object') && response.data.hasOwnProperty('success')) {
                    context.commit('subscribeClient', response.data)
                    let data = { id: response.data.success.data.mailing_group_id, count: 1, subscribe: 1 }
                    // context.dispatch('mailingGroups/changeCountMailingGroup', data, { root: true }) //пример с глобальным вызовом action из другого модуля
                    context.commit('changeCountMailingGroup', data)
                }
                return response.data
            // eslint-disable-next-line handle-callback-err
            }).catch((error) => {
                console.log('error subscribeClient ' + error)
            })
    },
    changeCountMailingGroup: (context, payload) => {
        context.commit('changeCountMailingGroup', payload)
    },
    unsubscribeAll: (context, payload) => {
        return axios.get(constConf.app_vk.url +
            '/app_vk/unsubscribe-all/' +
            payload.clientId +
            '?group_id=' + payload.groupId
        )
            .then(response => {
                return response.data
            // eslint-disable-next-line handle-callback-err
            }).catch((error) => {
                console.log('error unsubscribeAll ' + error)
            })
    },
    checkUser: (context, payload) => {
        return axios.post(constConf.app_vk.url + '/app_vk/check-user',
            payload)
            .then(response => {
                if (response.data.type === 'success') {
                    context.commit('writeSign', response.data.sign)
                }
                return response.data
                // eslint-disable-next-line handle-callback-err
            }).catch((error) => {
                console.log('error checkUser ' + error)
            })
    },
    loadMailingGroupsByGroupId: (context, payload) => {
        axios.defaults.withCredentials = true
        axios.get(constConf.app_vk.url + '/app_vk/all-by-group-id/' + payload.clientId + '?group_id=' + payload.groupId +
            '&sign=' + context.getters.sign).then(response => {
            if (response.data.type === 'actionGetUserAllowGroupListResult' && response.data.length !== 0) {
                context.commit('loadMailingGroups', response.data.data)
                context.commit('clients/loadMailingGroups', response.data.data, { root: true }) // пример с глобальным вызовом action из другого модуля
                context.commit('clients/changeBotIdModelDefault', response.data.data[0].bot_id, { root: true }) // пример с глобальным вызовом action из другого модуля
            }
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error get keyboards' + error)
        })
    },
    updateMailingGroups: (context, payload) => {
        context.commit('loadMailingGroups', payload)
    },
    changeAdminMode: (context, value) => {
        context.commit('changeAdminMode', value)
    },
    messagesAll: (context, payload) => {
        axios.defaults.withCredentials = true
        axios.get(constConf.app_vk.url + '/app_vk/messages-all/' + payload.clientId + '?group_id=' + payload.groupId +
            '&sign=' + context.getters.sign).then(response => {
            if (response.data.type === 'MessagesAllResult' && response.data.length !== 0) {
                // context.commit('loadMailingGroups', response.data.data)
                context.commit('messages/messageAll', response.data.response.data, { root: true }) // пример с глобальным вызовом action из другого модуля
                // context.commit('clients/changeBotIdModelDefault', response.data.data[0].bot_id, { root: true }) // пример с глобальным вызовом action из другого модуля
            }
            // eslint-disable-next-line handle-callback-err
        }).catch((error) => {
            console.log('error get keyboards' + error)
        })
    }
}
